export default "__VITE_ASSET__C4L9o0RL__"